









































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Location as RouteLocation } from 'vue-router';
import BaseMixin from '@/mixins/base';
import { SearchEntityType } from '@/modules/backend/Dto/SearchRequestData';
import { resolveModule } from '@/store';
import { SearchModule } from '@/store/search';
import { Company } from '@/modules/backend/Entities/Company';
import { Building } from '@/modules/backend/Entities/Building';
import { Location } from '@/modules/backend/Entities/Location';
import { Account } from '@/modules/backend/Entities/Account';
import { Counter } from '@/modules/backend/Entities/Counter';
import SearchbarResultList from '@/components/dashboard/SearchbarResultList.vue';

const DEBOUNCE_TIMEOUT = 500;

type SearchResponseEntityItem = Array<Company | Building | Location | Account | Counter>;

type SearchResultItem = {
  title: string;
  route: RouteLocation;
};

type SearchResultCategoryItem = {
  title: string;
  items: SearchResultItem[];
};

@Component({
  mixins: [BaseMixin],
  components: {
    'searchbar-result-list': SearchbarResultList
  }
})
export default class Searchbar extends Mixins(BaseMixin) {
  private readonly searchModule: SearchModule = resolveModule(SearchModule);

  private menuOpened = false;
  private searchInput = '';
  private debounceTimer: NodeJS.Timeout | undefined = undefined;

  private get items(): { title: string; items: { title: string; route: RouteLocation }[] }[] {
    let result: SearchResultCategoryItem[] = [];

    Object.keys(this.searchModule.items).forEach((entityName: string): void => {
      if (!['companies', 'buildings', 'locations', 'accounts', 'counters'].includes(entityName)) {
        return;
      }

      result = [...result, {
        title: this.getEntityName(entityName as SearchEntityType),
        items: (this.searchModule.items[entityName as SearchEntityType] as SearchResponseEntityItem).map((entity) => ({
          title: entity instanceof Counter ? entity.getSerialNumber().getCounter() : entity.getName(),
          route: entity.getRouteLocation()
        }))
      }];
    });

    return result;
  }

  private get selectedEntities(): SearchEntityType[] {
    return this.searchModule.entities;
  }

  @Watch('searchInput')
  @Watch('selectedEntities')
  private async searchDataChangedHandler(): Promise<void> {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    this.debounceTimer = setTimeout(async () => {
      await this.loadData();
      this.menuOpened = true;
    }, DEBOUNCE_TIMEOUT);
  }

  private getEntityName(entity: SearchEntityType): string {
    const strings = {
      companies: this.$t('search.category.companies').toString(),
      buildings: this.$t('search.category.buildings').toString(),
      locations: this.$t('search.category.locations').toString(),
      accounts: this.$t('search.category.accounts').toString(),
      counters: this.$t('search.category.counters').toString(),
    };

    if (Object.keys(strings).includes(entity)) {
      return strings[entity];
    }

    return '';
  }

  private async loadData(): Promise<void> {
    await this.searchModule.search(this.searchInput);
  }

  private navigate(location: RouteLocation): void {
    this.$router.push(location).catch(() => {
      // Do nothing
    });
    this.menuOpened = false;
  }
}
